import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
// eslint-disable-next-line
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import schema from './apollo-schema.json';
import USE_MARKETPLACE from '~/const/marketplace';
var fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema
});
export default function (_ref) {
  var store = _ref.store,
      req = _ref.req;

  var _ref2 = req || {},
      _ref2$header = _ref2.header,
      header = _ref2$header === void 0 ? {} : _ref2$header;

  var _store$getters$shared = store.getters['sharedEnv/getSharedEnv'],
      graphqlExternal = _store$getters$shared.graphqlExternal,
      graphqlInternal = _store$getters$shared.graphqlInternal;
  var locale = store.getters['i18n/locale'];
  var useCatalogv1 = store.$cookies.get('usecatalogv1');
  var displayMkpProducts = USE_MARKETPLACE({
    locale: locale,
    $cookies: store.$cookies
  });
  var xMdM = Object.entries(header).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return /^x-mdm-/i.test(key);
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    acc[key] = value;
    return acc;
  }, {});
  return {
    httpEndpoint: process.browser ? graphqlExternal : graphqlInternal,
    httpLinkOptions: {
      headers: _objectSpread({}, xMdM, header['correlation-id'] && {
        'correlation-id': header['correlation-id']
      }, header['mdm-client-ip'] && {
        'mdm-client-ip': header['mdm-client-ip']
      }, {
        'Ws-Cat-Version': useCatalogv1 ? 1 : 2
      }, displayMkpProducts && {
        'Source-Mkp-Products': 1
      }, {
        'Accept-Language': locale.iso
      })
    },
    cache: new InMemoryCache({
      fragmentMatcher: fragmentMatcher
    })
  };
}